module.exports = __webpack_public_path__ + "static/img/icon_bg.baefe315.png";